import api from "../api/api";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export const UploadFileToAzureDB = async (selectedFile, imageName) => {
  if (!selectedFile || !imageName) {
    console.warn("⚠️ Upload skipped: No file or imageName provided.");
    return { success: false, url: null };
  }

  try {
    const formData = new FormData();
    formData.append("file", selectedFile, imageName);
    formData.append("user[userId]", "DebaswiniMishra_acf9a301");
    formData.append("user[userName]", "Debaswini Mishra");
    formData.append("user[userType]", "observer");
    formData.append("user[uploadOrigin]", "tz_mis");

    const response = await axios.post(
      `https://test.thinkzone.in.net/nipun/uploadFile/public/${imageName}`,
      formData,
      {
        headers: {},
      },
    );

    const media = response?.data?.media;
    const url = media?.url || media?.originalUrl || response?.data?.url || null;

    console.log("✅ Media uploaded successfully:", url);
    return {
      success: true,
      url,
      media,
    };
  } catch (error) {
    if (error.response && error.response.status === 413) {
      console.error("❌ File too large:", imageName);
      toast.error("File is too large to upload!");
    } else {
      console.error("❌ Upload failed:", error.response?.data || error.message);
      toast.error(
        `Upload Failed: ${error.message} - ${JSON.stringify(error.response?.data || "")}`,
      );
    }
    return { success: false, url: null };
  }
};

export const deleteFileFromDB = (item) => {
  api
    .delete(`deleteFile/${item.split("/")[item.split("/").length - 1]}`)
    .then((res) => {
      console.log("delet response--->", res.status, res);
      if (res.status === 200) {
        // console.log("This has been called perhaps...");
      }
    })
    .catch((err) => {
      console.error("The following error happened------------>", err);
    });
};
